import { Injectable } from '@angular/core';
import { ApiService } from '@core/api.service';
import { MarketplaceService } from '@features/marketplace/marketplace.service';
import { MenuService } from '@services/common/menu.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  sidebarToggle$: Subject<any> = new Subject<any>();
  selectedMenu$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  initAvailableIntegrations() {
    return this._marketplaceService.collectionIntegration.reload().pipe(
      map(() => {
        const data = [...this._menuService.menu.values()];

        data
          .flatMap((group) => Array.from(group.items))
          .filter((item) => {
            return !!item[1].integrationId;
          })
          .forEach((item) => {
            const show = this._marketplaceService.hasIntegrationEnabled(item[1].integrationId);
            this._menuService.setMenu(item[1].groupName, item[1].title, { show }).applyMenu();
          });
      })
    );
  }

  updateAvailableIntegration(integrationId: string, isEnabled: boolean) {
    const data = [...this._menuService.menu.values()];

    data
      .flatMap((group) => Array.from(group.items))
      .filter((item) => {
        return item[1].integrationId && item[1].integrationId === integrationId;
      })
      .forEach((item) => {
        this._menuService.setMenu(item[1].groupName, item[1].title, { show: isEnabled }).applyMenu();
      });
  }

  constructor(
    private _api: ApiService,
    private _menuService: MenuService,
    private _marketplaceService: MarketplaceService
  ) {}
}
